module.exports = __webpack_public_path__ + "static/img/icon_1_mk.96c966f3.svg";